import { useState } from 'react';

const faqList = [
  {
    q: 'Что такое управленческие компетенции?',
    a: 'Это способность руководителя применять конкретные инструменты управления в реальных рабочих ситуациях и получать необходимый результат через команду. Это не просто знание теории менеджмента: знать инструмент и уметь применять его — не одно и то же. Поэтому развитие компетенций включает обучение, практику, внедрение и обратную связь.',
  },
  {
    q: 'Какие компетенции должен развивать руководитель?',
    a: 'Лидерство, постановку задач, делегирование, контроль, обратную связь, мотивацию, коммуникацию, управление конфликтами, принятие решений, переговоры, управление изменениями и развитие сотрудников. Конкретный набор приоритетных компетенций определяется задачей компании и управленческой ролью руководителя.',
  },
  {
    q: 'Как определить слабые управленческие компетенции?',
    a: 'Через диагностику: интервью с руководителем и вышестоящим руководством, анализ типичных управленческих ситуаций, обратную связь от сотрудников, оценку компетенций, анализ повторяющихся проблем, наблюдение за совещаниями и разбор реальных кейсов. Конкретный набор инструментов определяется задачей компании.',
  },
  {
    q: 'Чем развитие управленческих компетенций отличается от обычного тренинга?',
    a: 'Тренинг может дать инструменты и изменить понимание проблемы, но устойчивое изменение управленческого поведения требует практики и внедрения. Развитие компетенций — это процесс формирования нового поведения, а не разовая передача знаний, поэтому в нём есть диагностика, практика, внедрение и сопровождение.',
  },
  {
    q: 'Сколько времени занимает развитие управленческих навыков?',
    a: 'Зависит от формата и задачи: корпоративный тренинг занимает 1–3 дня, модульная программа — несколько встреч с практикой между ними, комплексная программа развития — несколько месяцев. Устойчивое изменение поведения формируется постепенно, через применение инструментов в реальной работе.',
  },
  {
    q: 'Можно ли разработать программу под конкретную компанию?',
    a: 'Да, адаптация — обязательный этап. Сначала проводится диагностика: определяем текущий уровень компетенций, реальные управленческие задачи и ожидания бизнеса, затем приоритизируем компетенции и настраиваем программу под отрасль, уровень участников и задачи компании.',
  },
  {
    q: 'Подходит ли программа для новых руководителей?',
    a: 'Да. Для новых руководителей это переход от роли специалиста к роли управленца: постановка задач, делегирование, контроль и обратная связь. Программа адаптируется под уровень участников и помогает быстрее освоить новую управленческую роль.',
  },
  {
    q: 'Можно ли развивать компетенции всей управленческой команды?',
    a: 'Да, работа с управленческой командой формирует единый язык и стандарты управления, что повышает согласованность решений и взаимодействие между подразделениями. Это особенно полезно для компаний, которые масштабируются или формируют кадровый резерв.',
  },
  {
    q: 'Можно ли проводить обучение онлайн?',
    a: 'Да, обучение проводится как очно в Минске и Беларуси, так и онлайн. Формат подбирается под задачу: корпоративный тренинг, модульная программа, бизнес-игры, коучинг руководителей, управленческая фасилитация или сопровождение.',
  },
  {
    q: 'Что происходит после обучения?',
    a: 'Руководители переносят инструменты в реальную работу, а при необходимости проводится сопровождение: разбираются реальные ситуации, корректируются подходы и оцениваются изменения в управленческой практике. Обучение не заканчивается тренингом.',
  },
  {
    q: 'Как оценить результат развития управленческих компетенций?',
    a: 'Через оценку изменений в управленческой практике: стала ли понятнее постановка задач, снизился ли микроменеджмент, улучшилась ли обратная связь, выросла ли самостоятельность команды. Мы определяем, какие изменения произошли в поведении руководителей, а не обещаем гарантированные финансовые показатели.',
  },
  {
    q: 'Можно ли сочетать тренинг и сопровождение?',
    a: 'Да, это наиболее эффективный вариант. Тренинг даёт инструменты, а сопровождение помогает закрепить их: разбираем реальные ситуации после обучения, поддерживаем внедрение и корректируем подходы, чтобы компетенции стали частью ежедневной работы.',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section id="faq" className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-4xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Часто задаваемые вопросы
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-14 max-w-3xl mx-auto leading-relaxed">
          Ответы на ключевые вопросы о развитии управленческих компетенций руководителей
        </p>

        <div className="space-y-4">
          {faqList.map((item, i) => (
            <div key={i} className="bg-white rounded-xl border border-gray-200 overflow-hidden">
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between px-6 py-5 text-left hover:bg-gray-50 transition-colors cursor-pointer"
              >
                <span className="font-bold text-gray-900 pr-4 text-sm md:text-base">{item.q}</span>
                <i className={`ri-arrow-down-s-line text-xl text-teal-600 flex-shrink-0 transition-transform ${openIndex === i ? 'rotate-180' : ''}`}></i>
              </button>
              <div className={`px-6 pb-5 ${openIndex === i ? '' : 'hidden'}`}>
                <p className="text-gray-600 leading-relaxed text-sm md:text-base">{item.a}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}